module.exports = __webpack_public_path__ + "static/media/cards.9e96bfc8.svg";